<script>
    import { onMount } from "svelte";

    let classificacao = [];
    let loading = true;
    let errorMessage = "";

    // Função para buscar os dados da API
    async function fetchClassificacao() {
        try {
            const response = await fetch(
                "https://linkagenda.com.br/torneio_domino/classificacao.php",
            );
            const data = await response.json();

            if (data.status === "sucesso") {
                classificacao = data.classificacao;
            } else {
                errorMessage = "Erro ao carregar a classificação.";
            }
        } catch (error) {
            errorMessage = "Erro ao conectar à API.";
        } finally {
            loading = false;
        }
    }

    // Agrupar por grupos
    function agruparPorGrupo(classificacao) {
        let grupos = {};
        classificacao.forEach((row) => {
            if (!grupos[row.grupo]) {
                grupos[row.grupo] = [];
            }
            grupos[row.grupo].push(row);
        });
        return grupos;
    }
    function reloadPage() {
        location.reload();
    }
    // Carregar os dados da classificação quando o componente for montado
    onMount(() => {
        fetchClassificacao();
        const interval = setInterval(reloadPage, 17000);

        // Limpa o intervalo quando o componente for destruído
        return () => {
            clearInterval(interval);
        };
    });
</script>

<div class="back">
    <!-- Verifica se está carregando ou se houve erro -->
    {#if loading}
        <div class="loading text-center">Carregando classificação...</div>
    {:else if errorMessage}
        <div class="error text-danger text-center">{errorMessage}</div>
    {:else}
        {#each Object.entries(agruparPorGrupo(classificacao)) as [grupo, partidas]}
            <div class="grupo mb-4">
                <h2 class="grupo-titulo text-center">Grupo {grupo}</h2>
                <div class="table-responsive">
                    <!-- Adicionando a classe table-responsive -->
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Dupla</th>
                                <th>P</th>
                                <th>SP</th>
                                <th>J</th>
                                <th>V</th>
                                <th>D</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each partidas as row, index}
                                <tr class={index < 2 ? "table-success" : ""}>
                                    <td>{row.dupla}</td>
                                    <td>{row.pontos}</td>
                                    <td>{row.saldo_pontos}</td>
                                    <td>{row.jogos}</td>
                                    <td>{row.vitorias}</td>
                                    <td>{row.derrotas}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        {/each}
    {/if}
    P=PONTOS<br />
    SP=SALDO DE PONTOS<br />
    J=JOGOS RELIZADOS<br />
    V=NÚMERO DE VITÓRIAS<br />
    D=NÚMERO DE DERROTAS<br />
</div>

<!-- Bootstrap CSS -->
<link
    rel="stylesheet"
    href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"
/>

<style>
    .back {
        background-image: url("/img/domino2.jpg");
        background-size: cover; /* Para cobrir toda a tela */
        background-position: center; /* Para centralizar a imagem */
    }
    .grupo-titulo {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
        color: #333;
    }

    .loading,
    .error {
        padding: 1rem;
        font-size: 1.2rem;
    }
</style>
